exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._root-used[data-v-5b0fb8c4]{padding-bottom:10px}._root-used .page-box[data-v-5b0fb8c4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._root-used .dis-sty[data-v-5b0fb8c4]{color:#ccc;cursor:not-allowed}._root-used .page-row[data-v-5b0fb8c4]{padding:5px 0}._root-used .warn-img[data-v-5b0fb8c4]{color:#f8b762}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b0fb8c4","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/console/components/contractApproval/unScopeUse.vue
// module id = DoWP
// module chunks = 7 55 110 187